import { memo } from 'react';
import { motion } from 'framer-motion';

import { useGetParams } from '../../hooks/useGetParams';

import styles from './Advt.module.css';

export const Advt = memo(() => {
  const { title, qrCode1, sizeQR, titleFontSize } = useGetParams();

  return (
    <div className={styles.wrapper}>
      {qrCode1 && (
        <motion.div
          initial={{ scale: 0 }}
          animate={{
            scale: [0, 1.1, 1],
            transition: {
              scale: {
                times: [0, 0.8, 1],
                duration: 1,
                ease: 'easeOut',
                delay: 1,
              },
            },
          }}
          exit={{
            scale: 0,
            transition: {
              scale: {
                duration: 0.5,
                delay: 0.5,
              },
            },
          }}
          className={styles.qrCode}
          style={{
            width: `${sizeQR}rem`,
            height: `${sizeQR}rem`,
          }}
        >
          <img src={qrCode1} alt="" />
        </motion.div>
      )}

      {title && (
        <div
          className={styles.titleBlock}
          style={{ fontSize: `${titleFontSize}rem` }}
        >
          <motion.div
            className={styles.title}
            initial={{ x: '-100%', opacity: 0 }}
            animate={{
              x: 0,
              opacity: 1,
              transition: {
                x: { delay: 1.9, duration: 1 },
                opacity: { delay: 1.9, duration: 0.1 },
              },
            }}
            exit={{
              x: '-100%',
              transition: {
                x: { delay: 0, duration: 0.5 },
              },
            }}
          >
            {title}
          </motion.div>
        </div>
      )}
    </div>
  );
});
